import styled, { css } from 'styled-components/macro';

export interface ScSpinnerProps {
  size: number;
  absoluteCenter?: boolean;
  center?: boolean;
  white?: boolean;
}

export const ScSpinner = styled.div<ScSpinnerProps>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  path {
    fill: ${({ theme, white }) =>
      white ? theme.whiteColor : theme.greenColor};
  }

  ${({ absoluteCenter, center }) => {
    if (absoluteCenter != null) {
      return css`
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      `;
    }

    if (center != null) {
      return css`
        margin: 0 auto;
      `;
    }
  }}
`;
